/* eslint-disable import/prefer-default-export */
import React from 'react';
import {
  Grid, styled,
} from '@mui/material';
import { keyframes } from '@emotion/react';
import AtriasLogo from '../../icons/AtriasLogo';

interface PageLoaderProps {
  image?: string;
}

const pulsate = keyframes`
  0% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    -webkit-transform: scale(0.9);
            transform: scale(0.9);
  }
  100% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
`;

const LoadingContainer = styled(Grid)(() => ({
  height: '100%',
}));

const LogoLoadingImage = styled('img')(() => ({
  height: '100px',
  width: '100px',
  animation: `${pulsate} 2.5s ease-in-out infinite both`,
}));

const LogoLoadingSpan = styled('span')(() => ({
  height: '100px',
  width: '100px',
  animation: `${pulsate} 2.5s ease-in-out infinite both`,
}));

const PageLoader: React.FC<PageLoaderProps> = (props: PageLoaderProps) => (
  <LoadingContainer container justifyContent="center" alignItems="center">
    {
      props.image ? (<LogoLoadingImage src={props.image} alt="Loading" />) : (
        <LogoLoadingSpan><AtriasLogo style={{ fontSize: 100 }} /></LogoLoadingSpan>)
    }

  </LoadingContainer>
);

PageLoader.defaultProps = {
  image: undefined,
};

export default PageLoader;
